import { EvaluationsDynamicTableStore } from './evaluations-store';

export function setupRepositories(storeBuilder) {
  storeBuilder.addRepository(new EvaluationsDynamicTableStore());
}
